<template>
  <b-modal v-model="modal" :title="title" size="md" :no-enforce-focus="true" :no-close-on-backdrop="true">
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <form @submit.prevent="updatepassword()" autocomplete="off">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="password">Senha</label>
                <input
                  id="password"
                  v-model="user.password"
                  name="password"
                  type="password"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.user.password.$error
                  }"
                />
                <div
                  v-if="submitted && !$v.user.password.required"
                  class="invalid-feedback"
                >
                  O campo senha é obrigatório.
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="repassword">Confirmar senha</label>
                <input
                  id="repassword"
                  v-model="user.repassword"
                  name="repassword"
                  type="password"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.user.repassword.$error
                  }"
                />
                <div
                  v-if="submitted && !$v.user.repassword.required"
                  class="invalid-feedback"
                >
                  O campo confirmar senha é obrigatório.
                </div>
                <span
                  class="invalid-feedback"
                  v-if="$v.user.repassword.$error && !$v.user.repassword.sameAs">As senhas devem ser iguais</span>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <template v-slot:modal-footer>
      <button type="submit" class="btn btn-primary mr-1" @click="updatepassword()">Atualizar Senha</button>
    </template>
  </b-modal>
</template>
<script>
// Import component
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
// import Multiselect from 'vue-multiselect'
import { mapActions, mapState } from 'vuex'
import { required, sameAs } from 'vuelidate/lib/validators'
import { errorMessage, successMessage } from '@/components/alertsMessages'
// import roleService from '@/pages/admin/roles/services'

export default {
  components: {
    Loading
    // Multiselect
  },
  data () {
    return {
      title: 'Atualizar senha',
      loading: true,
      selected: '',
      fullPage: true,
      submitted: false,
      user: {},
      modal: false
    }
  },
  validations () {
    return {
      user: {
        password: { required },
        repassword: { required, sameAsPassword: sameAs('password') }
      }
    }
  },
  methods: {
    ...mapActions('users', {
      getUser: 'getUser',
      changePassword: 'savePass'
    }),
    loadItem (id) {
      if (id) {
        this.title = 'Editar Usuário'
        this.getUser(id).then((data) => {
          this.user = this.data
          // if (this.data.roles) {
          //   this.selected = this.data.roles.data[0]
          // }
        }).then(() => {
          this.loading = false
        })
      }
    },
    // loadRoles () {
    //   roleService.list().then((res) => {
    //     this.roles = res.data.data
    //   })
    // },
    open (id = null) {
      this.modal = true
      this.loading = true
      // this.loadRoles()
      if (id) {
        this.loadItem(id)
        return
      }
      this.loading = false
    },
    async updatepassword () {
      this.submitted = true
      // if (this.selected) {
      //   this.user.role = this.selected.id
      // }
      this.$v.user.$touch()
      if (this.$v.user.$invalid) {
        window.scroll(0, 0)
        return
      }
      this.loading = true
      await this.changePassword(this.user).then(res => {
        let message = 'Sucesso: Dados armazenados com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.close()
        this.$emit('updated')
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        this.loading = false
      })
    },
    close () {
      this.submitted = false
      this.modal = false
      this.user = {}
      this.selected = ''
      this.title = 'Novo Usuário'
      this.$v.$reset()
    }
  },
  computed: {
    ...mapState('users', { data: 'admin_user' })
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
</style>
